import React from 'react';
import { Alert, Button, Card, Space, Table, Tag, Typography } from 'antd';

import { platformReadinessService } from '../../services/api';

const { Title, Text } = Typography;

const STATUS_COLOR = {
  READY: 'green',
  WARNING: 'gold',
  BLOCKED: 'red',
};

const CHECK_COLOR = {
  PASS: 'green',
  WARN: 'gold',
  FAIL: 'red',
};

const formatDateTime = (value) => {
  if (!value) return '-';
  const parsed = new Date(value);
  if (Number.isNaN(parsed.getTime())) return '-';
  return parsed.toLocaleString('pt-BR');
};

const getApiError = (requestError, fallback) => {
  const detail = requestError?.response?.data?.detail;
  if (typeof detail === 'string' && detail.trim()) {
    return detail;
  }
  return fallback;
};

const PlatformGoLiveReadinessPage = () => {
  const [data, setData] = React.useState(null);
  const [error, setError] = React.useState('');
  const [loading, setLoading] = React.useState(false);

  const loadReport = async () => {
    setLoading(true);
    setError('');
    try {
      const response = await platformReadinessService.getReadinessReport();
      setData(response?.data || null);
    } catch (requestError) {
      setData(null);
      setError(getApiError(requestError, 'Nao foi possivel carregar readiness report.'));
    } finally {
      setLoading(false);
    }
  };

  React.useEffect(() => {
    loadReport();
  }, []);

  const columns = [
    {
      title: 'Check',
      dataIndex: 'code',
      key: 'code',
      width: 320,
      render: (value) => <Text code>{value}</Text>,
    },
    {
      title: 'Status',
      dataIndex: 'status',
      key: 'status',
      width: 120,
      render: (value) => <Tag color={CHECK_COLOR[value] || 'default'}>{value || '-'}</Tag>,
    },
    {
      title: 'Mensagem',
      dataIndex: 'message',
      key: 'message',
    },
  ];

  return (
    <div style={{ padding: 24 }}>
      <Title level={2} style={{ marginTop: 0 }}>Go-live Readiness</Title>
      <Text type="secondary">
        Painel read-only para decisao de piloto: sem side effects e sem execucao de billing.
      </Text>

      {error ? (
        <Alert
          type="error"
          showIcon
          style={{ marginTop: 16 }}
          message="Falha ao carregar readiness"
          description={error}
        />
      ) : null}

      <Card size="small" style={{ marginTop: 16 }} loading={loading}>
        <Space direction="vertical" size={8}>
          <Space wrap>
            <Text strong>Ambiente:</Text>
            <Tag>{data?.environment || '-'}</Tag>
          </Space>
          <Space wrap>
            <Text strong>Status:</Text>
            <Tag color={STATUS_COLOR[data?.readiness] || 'default'}>{data?.readiness || '-'}</Tag>
          </Space>
          <Space wrap>
            <Text strong>Gerado em:</Text>
            <Text>{formatDateTime(data?.generated_at)}</Text>
          </Space>
          <Button type="primary" onClick={loadReport} loading={loading}>Refresh</Button>
        </Space>
      </Card>

      <Card size="small" title="Checks" style={{ marginTop: 16 }} loading={loading}>
        <Table
          rowKey={(row) => row.code}
          columns={columns}
          dataSource={Array.isArray(data?.checks) ? data.checks : []}
          pagination={false}
          size="small"
        />
      </Card>
    </div>
  );
};

export default PlatformGoLiveReadinessPage;
